import { actionLocation, CompareVehicle } from '@cinch/oxd-redux/compare/src/interfaces'

import * as types from './types'

export const addVehicle = (vehicle: CompareVehicle, location: actionLocation) => ({
  type: types.COMPARE_ADD,
  payload: vehicle,
  meta: { location },
})
export const closeDrawer = () => ({ type: types.COMPARE_CLOSE })
export const openDrawer = () => ({ type: types.COMPARE_OPEN })
export const removeVehicle = (vehicleId: string | number, location: actionLocation) => ({
  type: types.COMPARE_REMOVE,
  payload: vehicleId,
  meta: { location },
})
